export default __webpack_public_path__ + "static/media/sky.9725f472.svg";